import { render, staticRenderFns } from "./AddressFormV2.vue?vue&type=template&id=389ac990&scoped=true&"
import script from "./AddressFormV2.vue?vue&type=script&lang=js&"
export * from "./AddressFormV2.vue?vue&type=script&lang=js&"
import style0 from "./AddressFormV2.vue?vue&type=style&index=0&id=389ac990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ac990",
  null
  
)

export default component.exports